import { render } from "./MasterOrdersList.vue?vue&type=template&id=06288c22&scoped=true"
import script from "./MasterOrdersList.vue?vue&type=script&lang=js"
export * from "./MasterOrdersList.vue?vue&type=script&lang=js"

import "./MasterOrdersList.vue?vue&type=style&index=0&id=06288c22&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06288c22"]])

export default __exports__